import { useQuery } from "@tanstack/react-query";
import {
  passkeyQueryKeys,
  passkeyRepository,
} from "../repositories/passkey.repository";
import { useAuth } from "../auth/useAuth";

export function usePasskeyCredentialsQuery() {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: passkeyQueryKeys.credentials,
    queryFn: async () => {
      const result = await passkeyRepository.listCredentials();
      return result.credentials;
    },
    enabled: isAuthenticated,
  });
}

export default usePasskeyCredentialsQuery;
